import { useAuth } from '@backoffice-frontend/authentication'
import { jwtDecode } from 'jwt-decode'

type TemporaryBackofficeSessionToken = {
  temporarySessionId?: string
}

/**
 * Id of the temporary Backoffice session the current token was issued for, or
 * `undefined` when the actor is not inside one.
 *
 * The token is the authoritative source: it is the credential the backend
 * authorizes the session actions against, and reading it needs no network
 * request, so callers can cheaply gate session UI and queries on it.
 */
export const useTemporarySessionId = (): string | undefined => {
  const { token } = useAuth()

  return token
    ? jwtDecode<TemporaryBackofficeSessionToken>(token).temporarySessionId
    : undefined
}
